
import { useEffect, useState, useRef, ReactNode } from "react";
import { useUiStore } from "src/components/main/uiStore";
//-------------------------------------------------
import Footer from "src/components/common/frame/footer";
import {
    myAxios,
    addslashes,
    boolAndReducer} from "src/components/common/functions";
import { useLoaderData } from "react-router-dom";
//-------------------------------------------------
type column = { Field: string, Type: string, Null: string, Key: string, Default: string, Extra: string };
export default function Database(){
    // insert a row
    const tables = useLoaderData() ?? [];
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const ref = useRef<HTMLTextAreaElement>(null);
    const cusRef = useRef<HTMLDivElement>(null);
    const refFilters = useRef<HTMLDetailsElement>(null);
    const refSelections = useRef<HTMLDetailsElement>(null);
    //-------------------------------------------------
    const [filterWords, setFilterWords] = useState("");
    //************************************************
    const [historys, setHistorys] = useState<string[]>([]);
    const [cusCur, setCusCur] = useState({pos: [-1, -1], value: ""});
    const [sql, setSql] = useState("");
    const [needle, setNeedle] = useState("");
    const [submittedNeedle, setSubmittedNeedle] = useState("");
    interface SearchResult {
        table: string;
    }
    const [allSerach, setAllSerach] = useState<SearchResult[]>([]);
    const [customTable, setCustomTable] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const filteredCustomTable = customTable.filter(u => 
        filterWords === ""?true:
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const customTableSliced = filteredCustomTable.slice(indexOfFirstItem, indexOfLastItem);
    //************************************************
    const submitRef = useRef<HTMLButtonElement>(null);
    const [limit, setLimit] = useState(5);
    const [prevLimit, setPrevLimit] = useState(1);
    const [pageNum, setPageNum] = useState(1);
    const [prevPageNum, setPrevPageNum] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [primaryKey, setPrimaryKey] = useState("");
    const [cur, setCur] = useState({pos: [-1, -1], value: ""});
    const defaultSort = {key: "", direction: ""};
    const [sort, setSort] = useState(defaultSort);
    const [prevSort, setPrevSort] = useState(defaultSort);
    const [data, setData] = useState([]);
    const [table, setTable] = useState("");
    const [prevTable, setPrevTable] = useState("");
    const [columns, setColumns] = useState<column[]>([]);
    const [selections, setSelections] = useState<string[]>([]);
    const [prevSelections, setPrevSelections] = useState<string[]>([]);
    const selectionsSQL = selections.map(selection => `\`${selection}\``).join(", ");
    const [showColumnProperty, setShowColumnProperty] = useState(false);
    interface Filter {
        operator: string;
        key: string;
        value: string;
        exact: boolean;
        caseSensitive: boolean;
    }
    const [filters, setFilters] = useState<Filter[]>([]);
    const [prevFilters, setPrevFilters] = useState<Filter[]>([]);
    // for case sensitive: 
    // COLLATE `latin1_general_cs` create error 
    // because the column collation is `utf8_unicode_ci`. 
    // `BINARY` works well.
    const filtersSQL = "WHERE " + filters.map(filter => 
        (filter.exact?
            `${filter.caseSensitive?"BINARY ":""}\`${filter.key}\` = "${addslashes(filter.value)}"`
            :
            `INSTR(${filter.caseSensitive?"BINARY ":""}\`${filter.key}\`, "${addslashes(filter.value)}") > 0`
        ) 
        + 
        ` ${filter.operator} `
    ).join("").slice(0, -2);
    const filteredData = data.filter(u => 
        filterWords === ""?true:
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentIndex = (pageNum - 1) * limit;
    const totalPages = Math.ceil(totalRows / limit) || 1;
    //-------------------------------------------------
    const filterChange = JSON.stringify(filters) !== JSON.stringify(prevFilters);
    const selectionsChange = JSON.stringify([...selections].sort()) !== JSON.stringify([...prevSelections].sort());
    const limitChange = limit !== prevLimit;
    const pageNumChange = pageNum !== prevPageNum;
    const tableChange = table !== prevTable;
    const sortChange = JSON.stringify(sort) !== JSON.stringify(prevSort);
    //-------------------------------------------------
    const loadData = async () => {
        if(primaryKey === ""){
            window.alert("No primary key for selected table.");
            return;
        }
        if(refFilters.current){
            refFilters.current.open = false;
        }
        if(refSelections.current){
            refSelections.current.open = false;
        }
        let localCurrentIndex = currentIndex;
        if(filterChange || limitChange){
            setPageNum(1);
            setPrevPageNum(1);
            localCurrentIndex = 0;
        }
        const formData = new FormData();
        formData.append("action", "Read");
        formData.append("primaryKey", primaryKey);
        formData.append("where", filters.length?filtersSQL:"");
        formData.append("order", sort.key !== ""?`ORDER BY \`${sort.key}\` ${sort.direction}`:"");
        formData.append("selection", selectionsSQL);
        formData.append("table", table);
        formData.append("limit", `${localCurrentIndex},${limit}`);
        //--------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "server/database.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //--------------------------------------------------------
        setPrevLimit(limit);
        setPrevPageNum(pageNum);
        setPrevFilters(filters);
        setPrevTable(table);
        setPrevSelections(selections);
        setPrevSort(sort);

        setTotalRows(res.data.totalRows);
        setData(res.data.rows);
    }
    //-------------------------------------------------
    useEffect(() => {
        if(ref.current){
            ref.current.focus();
        }
    },[cur])
    useEffect(() => {
        if(cusRef.current){
            cusRef.current.focus();
        }
    },[cusCur])
    const operate = (content: string, needle: string): ReactNode[] => {
        const regex = new RegExp(needle, "i");
        const parts = content.split(regex);
        const matches = content.match(regex);
        const result: ReactNode[] = [];
        for (let i = 0; i < parts.length; i++) {
            result.push(parts[i]);
            if (matches && matches[i]) {
            result.push(
                <span key = {`m-${i}`} className = "text-danger">
                    {matches[i]}
                </span>
            );
            }
        }
        return result;
    };
    //-------------------------------------------------
    return (
        <div className = "cssContent pb8rem">
            <nav className = "d-flex align-items-center mt-2 mb-4">
                <span className = "d-inline-flex align-items-center me-3">
                    <label
                        children = "Search:"
                        htmlFor = "search"
                        className = "me-2"
                    />
                    <input
                        id = "search"
                        className = "form-control inline w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                </span>
            </nav>
            {<div>
                <form onSubmit = {e => {
                    e.preventDefault();
                    loadData();
                }}>
                <details className = "mx-3">
                    <summary
                        children = "Search In All Databases"
                        className = "h5"
                    />
                    <div className = "mt-3 d-flex align-items-center">
                        <input className = "form-control" value = {needle} onChange = {e => setNeedle(e.currentTarget.value)}/>
                        <div>
                            <button
                                children = "Go"
                                type = "button"
                                className = "ms-2 btn btn-primary"
                                onClick = {async() => {
                                    if(needle === ""){
                                        window.alert("No input.");
                                        return;
                                    }
                                    if(!window.confirm("Are you sure to search this needle in entire databases?")) return;
                                    const formData = new FormData();
                                    formData.append("action", "Search In All");
                                    formData.append("needle", needle);
                                    //--------------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios({ fileName: "server/database.php", formData: formData });
                                    setShowLoader(false);
                                    if(!res) return;
                                    //--------------------------------------------------------
                                    setSubmittedNeedle(needle);
                                    setAllSerach(res.data);
                                }}
                            />
                        </div>
                    </div>
                    <div>{allSerach.map((item, itemIndex) => 
                        <div key = {itemIndex} className = "my-3">
                            <span className = "h5 text-primary">
                                {item.table}
                            </span>
                            {Object.entries(item).filter(([_, value]) => value !== null && value.toLowerCase().includes(submittedNeedle.toLocaleLowerCase())).map(([key, value]) => 
                            <li key = {key}>
                                <span className = "fw-bold me-2">
                                    {key}
                                </span>
                                {operate(value, submittedNeedle)}
                            </li>)}
                        </div>)}
                    </div>
                </details>
                <details className = "mt-3 mx-3">
                    <summary className = "h5">Customization SQL query</summary>
                    <div className = "flex align-items-center">
                        <textarea className = "form-control fw-bold" style = {{ fontSize: "2.5rem"}} value = {sql} onChange = {e => setSql(e.currentTarget.value)}/>
                        <div className = "mt-2">
                            <button
                                children = "Execute"
                                type = "button"
                                className = "ms-2 btn btn-primary"
                                onClick = {async() => {
                                    if(!window.confirm("Are you sure to execute this sql?")) return;
                                    const formData = new FormData();
                                    formData.append("action", "SQL");
                                    formData.append("sql", sql);
                                    //--------------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios({ fileName: "server/database.php", formData: formData });
                                    setShowLoader(false);
                                    if(!res) return;
                                    //--------------------------------------------------------
                                    setCustomTable([]);
                                    setHistorys([...historys, sql]);
                                    if(res.data !== ""){
                                        setCustomTable(res.data);
                                    }else{
                                        window.alert("Success!");
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {historys.length?
                    <div className = "mt-3 border rounded">
                        <h4 className = "m-2">History</h4>
                        {historys.map((line, lineIndex) => 
                        <li
                            key = {lineIndex}
                            className = "p-2 user-select-text" 
                        >
                            {line}
                            <button
                                children = "Copy"
                                type = "button"
                                className = "ms-3 btn btn-success"
                                onClick = {() => {
                                    if(sql !== "" && !window.confirm("Are you sure to overwrite the sql?")) return;
                                    setSql(line);
                                }}
                            />
                        </li>)}
                    </div>:null}
                    {customTable.length?<div style = {{marginBottom: "150px"}}>
                    <div className = "table-responsive mt-3">
                        dsfas
                    <table className = "table">
                        <thead>
                            <tr>
                                {Object.keys(customTable[0]).map((key, keyIndex) => <th key = {keyIndex}>{key}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {customTableSliced.map((item, itemIndex) => 
                            <tr key = {itemIndex}>
                                {Object.values(item).map((value, valueIndex) => 
                                cusCur.pos[0] === itemIndex && cusCur.pos[1] === valueIndex?
                                <td key = {valueIndex} className = {itemIndex === customTableSliced.length - 1?"bottomTableBorder":""}>
                                    <div
                                        ref = {cusRef}
                                        onBlur = {() => setCusCur({pos: [-1, -1], value: ""})}
                                        style = {{
                                            minWidth: 500, 
                                            minHeight: 200
                                        }}
                                        className = "form-control user-select-text"
                                    >
                                        {cusCur.value}
                                    </div>
                                </td>:
                                <td key = {valueIndex} className = {itemIndex === customTableSliced.length - 1?"bottomTableBorder":""}
                                    onDoubleClick = {() => {
                                        setCusCur({
                                            pos: [itemIndex, valueIndex],
                                            value: String(value)
                                        });
                                    }}
                                >
                                    {value === null?"*null*":String(value).length <= 33? String(value) : String(value).slice(0, 33) + "..."}
                                </td>
                                )}
                            </tr>)}
                        </tbody>
                    </table>
                    </div>
                    {filteredCustomTable.length?
                    <Footer
                        pa = ""
                        length = {filteredCustomTable.length}
                        
    
                        currentPage = {currentPage}
                        setCurrentPage = {setCurrentPage}
                        itemsPerPage = {itemsPerPage}
                        setItemsPerPage = {setItemsPerPage}
                    />
                    :null}
                    </div>:<></>}
                </details>
                <div className = "m-3 d-flex">
                    <select
                        className = "form-control"
                        value = {table}
                        onChange = {async e => {
                            const value = e.currentTarget.value;
                            //----------------------
                            if(value === ""){
                                setTable(value);
                                setData([]);
                                setFilters([]);
                                setShowColumnProperty(false);
                                setSort(defaultSort);
                                setPageNum(1);
                                setTotalRows(0);
                                setColumns([]);
                                setSelections([]);
                                setPrimaryKey("");
                                return;
                            }
                            const formData = new FormData();
                            formData.append("table", value);
                            formData.append("action", "Read Columns");
                            //--------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/database.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //--------------------------------------------------------
                            setTable(value);
                            setData([]);
                            setFilters([]);
                            setShowColumnProperty(false);
                            setSort(defaultSort);
                            setPageNum(1);
                            setTotalRows(0);
                            setColumns(res.data.columns);
                            setSelections(res.data.columns.map((column:column) => column.Field));
                            setPrevSelections(res.data.columns.map((column:column) => column.Field));
                            setPrimaryKey(res.data.primaryKey);
                        }}
                    >
                        <option value = "">Select</option>
                        {tables.map((item:string, index:number) => 
                            <option key = {index}>{item}</option>
                        )}
                    </select>
                    {table !== ""?<>
                    {filterChange || limitChange || pageNumChange || tableChange || selectionsChange || sortChange?
                    <button
                        children = "Load Data"
                        ref = {submitRef}
                        type = "submit"
                        className = "ms-3 btn btn-info"
                        style = {{
                            whiteSpace: "nowrap"
                        }}
                        onClick = {() => {
                            if(refFilters.current) refFilters.current.open = true;
                        }}
                    />:
                    <button className = "ms-3 btn btn-success" style = {{whiteSpace: "nowrap"}} type = "submit">
                        Refresh
                    </button>}
                    </>:<></>}
                </div>
                {columns.length?<>
                <details className = "mx-3" ref = {refFilters}>
                    <summary className = "h5">Filter Criteria</summary>
                    {filters.map((filter, fitlerIndex) => 
                    <div key = {fitlerIndex} className = "my-2">
                        <label>Key</label>
                        <select
                            required
                            className = "ms-2 me-4 form-control inline"
                            value = {filter.key}
                            onChange = {e => {
                                setFilters([...filters.slice(0, fitlerIndex), {...filter, key: e.currentTarget.value}, ...filters.slice(fitlerIndex + 1)]);
                            }}
                        >
                            <option value = "">Select</option>
                            {columns.filter(column => !filters.map(f => f.key).includes(column.Field) || column.Field === filter.key).map((column, columnIndex) => <option key = {columnIndex}>{column.Field}</option>)}
                        </select>
                        <label>Exact</label>
                        <input
                            className = "ms-2 me-4"
                            style = {{
                                verticalAlign: "middle",
                                width: 30,
                                height: 30,
                                marginBottom: 3
                            }}
                            type = "checkbox"
                            checked = {filter.exact}
                            onChange = {e => {
                                if(e.currentTarget.checked){
                                    setFilters([...filters.slice(0, fitlerIndex), {...filter, exact: true}, ...filters.slice(fitlerIndex + 1)]);
                                }else{
                                    setFilters([...filters.slice(0, fitlerIndex), {...filter, exact: false}, ...filters.slice(fitlerIndex + 1)]);
                                }
                            }}
                        />
                        <label>Case Sensitive</label>
                        <input
                            className = "ms-2 me-4"
                            style = {{
                                verticalAlign: "middle",
                                width: 30,
                                height: 30,
                                marginBottom: 3
                            }}
                            type = "checkbox"
                            checked = {filter.caseSensitive}
                            onChange = {e => {
                                if(e.currentTarget.checked){
                                    setFilters([...filters.slice(0, fitlerIndex), {...filter, caseSensitive: true}, ...filters.slice(fitlerIndex + 1)]);
                                }else{
                                    setFilters([...filters.slice(0, fitlerIndex), {...filter, caseSensitive: false}, ...filters.slice(fitlerIndex + 1)]);
                                }
                            }}
                        />
                        <label>Value</label>
                        <input
                            type = "text"
                            className = "ms-2 me-4 form-control inline"
                            value = {filter.value}
                            onChange = {e => {
                                setFilters([...filters.slice(0, fitlerIndex), {...filter, value: e.currentTarget.value}, ...filters.slice(fitlerIndex + 1)]);
                            }}
                        />
                        {fitlerIndex !== filters.length - 1?<>
                        <label>Operator</label>
                        <select
                            required
                            className = "ms-2 me-4 form-control inline"
                            value = {filter.operator}
                            onChange = {e => {
                                setFilters([...filters.slice(0, fitlerIndex), {...filter, operator: e.currentTarget.value}, ...filters.slice(fitlerIndex + 1)]);
                            }}
                        >
                            <option value = "">Select</option>
                            <option>AND</option>
                            <option>OR</option>
                        </select>
                        </>:<></>}
                        <button
                            children = "x"
                            type = "button"
                            className = "btn btn-danger"
                            onClick = {() => {
                                if(filters.length === 1){
                                    setFilters([]);
                                }else if(fitlerIndex === filters.length - 1){
                                    setFilters([...filters.slice(0, fitlerIndex - 1), {...filters[fitlerIndex - 1], operator: ""}]);  
                                }else{
                                    setFilters([...filters.slice(0, fitlerIndex), ...filters.slice(fitlerIndex + 1)]);
                                }
                            }}
                        />
                    </div>)}
                    <div>
                        <button
                            children = "Add Criterion"
                            type = "button"
                            className = "btn btn-primary"
                            onClick = {() => {
                                setFilters([...filters, {operator: "", key: "", value: "", exact: false, caseSensitive: false}]);
                            }}
                        />
                    </div>
                </details>
                <details className = "mx-3" ref = {refSelections}>
                    <summary className = "h5">Selection</summary>
                    <div>
                        <button children = "Select All" type = "button" className = "btn btn-success" onClick = {() => setSelections(columns.map(column => column.Field))}/>
                        <button children = "Deselect All" type = "button" className = "ms-3 btn btn-danger" onClick = {() => setSelections([])}/>
                    </div>
                    {!columns.length?<></>:
                    <div className = "table-responsive my-3">
                    <table className = "table text-center text-nowrap-descendant">
                        <tbody>
                        <tr>
                            <th>Field</th>
                            <th>Type</th>
                            <th>Null</th>
                            <th>Key</th>
                            <th>Default</th>
                            <th>Extra</th>
                            <th></th>
                        </tr>
                        {columns.map((column, columnIndex) => 
                        <tr key = {columnIndex} className = "text-nowrap my-2">
                            <td style={{color: "darkred"}}>{column.Field}</td>
                            <td>{column.Type}</td>
                            <td>{column.Null}</td>
                            <td>{column.Key}</td>
                            <td>{column.Default}</td>
                            <td>{column.Extra}</td>
                            <td>
                                <input
                                    className = "ms-2 me-4"
                                    style = {{
                                        verticalAlign: "middle",
                                        width: 30,
                                        height: 30,
                                        marginBottom: 3
                                    }}
                                    type = "checkbox"
                                    checked = {selections.includes(column.Field)}
                                    onChange = {e => {
                                        if(e.currentTarget.checked){
                                            setSelections([...selections, column.Field]);
                                        }else{
                                            setSelections(selections.filter(selection => selection !== column.Field));
                                        }
                                    }}
                                />
                            </td>
                        </tr>)}
                        </tbody>
                    </table>
                    </div>
                    }
                    
                </details>
                <div className = "blk5 mx-3" style = {{display: "flex"}}>
                    <div className = "my-2">
                        <label>Number Per Page</label>
                        <select
                            className = "ms-2 me-4 form-control inline"
                            value = {limit}
                            onChange = {e => {
                                setLimit(Number(e.currentTarget.value));
                                setPageNum(1);
                            }}
                        >
                            <option>1</option>
                            <option>5</option>
                            <option>10</option>
                            <option>25</option>
                            <option>50</option>
                            <option>100</option>
                        </select>
                    </div>
                    <div className = "my-2">
                        <label>Page Number</label>
                        <select
                            className = "ms-2 me-4 form-control inline"
                            value = {pageNum}
                            onChange = {e => setPageNum(Number(e.currentTarget.value))}
                        >
                            {Array(totalPages).fill(null).map((_, index) => <option key = {index}>{index + 1}</option>)}
                        </select>
                    </div>
                    <div className = "my-2">
                        <label>Total</label>
                        <input className = "ms-2 form-control inline" style = {{maxWidth: 100}} readOnly value = {totalRows}/>
                    </div>
                    <div className = "my-2 ms-3">
                        <button
                            children = "Show Column Property"
                            type = "button"
                            className = {showColumnProperty?"btn btn-primary":"btn border"}
                            onClick = {() => {
                                setShowColumnProperty(s => !s);
                            }}
                        />
                    </div>
                </div>
                {!filteredData.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                <table className = "table">
                    <thead>
                        <tr>
                            <th>Field</th>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, columnIndex) => 
                            <th
                                className = "pointer"
                                key = {columnIndex}
                            >
                                <button
                                    children = {<>
                                        {column.Field}
                                        {column.Field === sort.key?
                                        <span>{sort.direction === "ASC"?"⬆️":"⬇️"}</span>
                                        :<></>}
                                    </>}
                                    type = "button"
                                    className = "noButtonStyle"
                                    onClick = {() => {
                                    if(column.Field === sort.key){
                                        if(sort.direction === "ASC"){
                                            setSort({key: column.Field, direction: "DESC"});
                                        }else if(sort.direction === "DESC"){
                                            setSort(defaultSort);
                                        }
                                    }else{
                                        setSort({key: column.Field, direction: "ASC"});
                                    }
                                }}
                                />
                            </th>)}
                            <th></th>
                        </tr>
                        {showColumnProperty?<>
                        <tr>
                            <td className = "fw-bold">Type</td>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, columnIndex) => <td key = {columnIndex}>{column.Type}</td>)}
                            <td></td>
                        </tr>
                        <tr>
                            <td className = "fw-bold">Null</td>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, columnIndex) => <td key = {columnIndex}>{column.Null}</td>)}
                            <td></td>
                        </tr>
                        <tr>
                            <td className = "fw-bold">Key</td>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, columnIndex) => <td key = {columnIndex}>{column.Key}</td>)}
                            <td></td>
                        </tr>
                        <tr>
                            <td className = "fw-bold">Default</td>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, columnIndex) => <td key = {columnIndex}>{column.Default === null?"*null*":column.Default}</td>)}
                            <td></td>
                        </tr>
                        <tr>
                            <td className = "fw-bold">Extra</td>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, columnIndex) => <td key = {columnIndex}>{column.Extra}</td>)}
                            <td></td>
                        </tr>
                        </>:<></>}
                        
                    </thead>
                    <tbody className = "user-select-text">
                        {filteredData.length?
                        filteredData.map((item, itemIndex) => 
                        <tr key = {itemIndex}>
                            <td className = {itemIndex === filteredData.length - 1?"bottomTableBorder":""}>
                                {prevLimit * (prevPageNum - 1) + itemIndex + 1}
                            </td>
                            {columns.filter(column => prevSelections.includes(column.Field)).map((column, valueIndex) => cur.pos[0] === itemIndex && cur.pos[1] === valueIndex?
                            <td key = {valueIndex} className = {itemIndex === filteredData.length - 1?"bottomTableBorder":""}>
                                <textarea
                                    onFocus = {e => {
                                        const target = e.currentTarget;
                                        target.selectionStart = 
                                        target.selectionEnd = 
                                        target.value.length;
                                    }}
                                    ref = {ref}
                                    onBlur = {async e => {
                                        if(submitRef.current !== null){
                                            submitRef.current.click();
                                            return;
                                        }
                                        if(e.currentTarget.value === item[column.Field]){
                                            setCur({...cur, pos: [-1, -1]});
                                            return;
                                        }
                                        if(primaryKey === "" || item[primaryKey] === undefined){
                                            window.alert("No primary key found.");
                                            setCur({...cur, pos: [-1, -1]});
                                            return;
                                        }
                                        if(!window.confirm("Are you sure to update this item?")){
                                            window.setTimeout(() => {
                                                if(ref.current) ref.current.focus();
                                            }, 0)
                                            return;
                                        }
                                        const formData = new FormData();
                                        formData.append("action", "Update");
                                        formData.append("table", table);
                                        formData.append("key", Object.keys(item)[valueIndex]); 
                                        formData.append("value", e.currentTarget.value);
                                        formData.append("primaryKey", primaryKey);
                                        formData.append("primaryKeyValue", item[primaryKey]);
                                        //--------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios({ fileName: "server/database.php", formData: formData });
                                        setShowLoader(false);
                                        if(!res) return;
                                        //--------------------------------------------------------
                                        setCur({...cur, pos: [-1, -1]});
                                        loadData();
                                    }}
                                    style = {{
                                        minWidth: 500, 
                                        minHeight: 200
                                    }}
                                    className = "form-control"
                                    value = {cur.value}
                                    onChange = {e => {setCur({...cur, value: e.currentTarget.value})}}
                                />
                            </td>:
                            <td key = {valueIndex} className = {itemIndex === filteredData.length - 1?"bottomTableBorder":""}
                                onDoubleClick = {() => {
                                    setCur({
                                        pos: [itemIndex, valueIndex],
                                        value: item[column.Field]
                                    });
                                }}
                            >
                                {item[column.Field] === null ? "*null*" : !Number.isNaN(item[column.Field]) ? item[column.Field]: (item[column.Field] as string).length <= 32 ? item[column.Field] : (item[column.Field] as string).slice(0, 32) + "..."}
                            </td>)}
                            <td className = {itemIndex === filteredData.length - 1?"bottomTableBorder":""}>
                                {prevSelections.includes(primaryKey)?
                                <button
                                    children = "x"
                                    type = "button"
                                    className = "btn btn-danger"
                                    onClick = {async () => {
                                        if(submitRef.current !== null){
                                            submitRef.current.click();
                                            return;
                                        }
                                        if(!window.confirm("Are you sure to delete this item?")) return;
                                        if(!primaryKey){
                                            window.alert("No primary key found.");
                                            return;
                                        }
                                        const formData = new FormData();
                                        formData.append("action", "Delete");
                                        formData.append("table", table);
                                        formData.append("primaryKey", primaryKey);
                                        formData.append("primaryKeyValue", item[primaryKey]);
                                        //--------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios({ fileName: "server/database.php", formData: formData });
                                        setShowLoader(false);
                                        if(!res) return;
                                        //--------------------------------------------------------
                                        setCur({...cur, pos: [-1, -1]});
                                        loadData();
                                    }}
                                />
                                :<></>}
                            </td>
                        </tr>
                        ):
                        <tr><td className = "text-center h5" style = {{whiteSpace: "nowrap"}}>No Data Found</td></tr>}
                    </tbody>
                </table>
                </div>}
                </>:<></>}
                </form>
            </div>}
        </div>
    )
}

export async function databaseTablesLoader() {
  const formData = new FormData();
  formData.append("action", "Read Tables");
  const res = await myAxios({
    fileName: "server/database.php",
    formData
  });
  if (!res) {
    throw new Response("Failed to load tables", { status: 500 });
  }
  return res.data;
}